import { Country } from "@Types/cart";

const countries: { [key: string]: Country[] } = {
  en: [
    { name: "Andorra", tag: "AND" },
    { name: "Australia", tag: "AUS" },
    { name: "Austria", tag: "AUT" },
    { name: "Belgium", tag: "BEL" },
    { name: "Canada", tag: "CAN" },
    { name: "Chile", tag: "CHL" },
    { name: "China", tag: "CHN" },
    { name: "Colombia", tag: "COL" },
    { name: "Croatia", tag: "HRV" },
    { name: "Czech Republic", tag: "CZE" },
    { name: "Denmark", tag: "DNK" },
    { name: "Estonia", tag: "EST" },
    { name: "Finland", tag: "FIN" },
    { name: "France", tag: "FRA" },
    { name: "Germany", tag: "DEU" },
    { name: "Greece", tag: "GRC" },
    { name: "Hong Kong", tag: "HKG" },
    { name: "Hungary", tag: "HUN" },
    { name: "Ireland", tag: "IRL" },
    { name: "Italy", tag: "ITA" },
    { name: "Jersey", tag: "JEY" },
    { name: "Luxembourg", tag: "LUX" },
    { name: "Malta", tag: "MLT" },
    { name: "Martinique", tag: "MTQ" },
    { name: "Mayotte", tag: "MYT" },
    { name: "Mexico", tag: "MEX" },
    { name: "Monaco", tag: "MCO" },
    { name: "Morocco", tag: "MAR" },
    { name: "Netherlands", tag: "NLD" },
    { name: "New Zealand", tag: "NZL" },
    { name: "Norway", tag: "NOR" },
    { name: "Poland", tag: "POL" },
    { name: "Portugal", tag: "PRT" },
    { name: "Qatar", tag: "QAT" },
    { name: "Romania", tag: "ROU" },
    { name: "Saint Barthélemy", tag: "BLM" },
    { name: "Saint Martin", tag: "MAF" },
    { name: "Singapore", tag: "SGP" },
    { name: "Slovakia", tag: "SVK" },
    { name: "Slovenia", tag: "SVN" },
    { name: "South Africa", tag: "ZAF" },
    { name: "Spain", tag: "ESP" },
    { name: "Sweden", tag: "SWE" },
    { name: "Switzerland", tag: "CHE" },
    { name: "Thailand", tag: "THA" },
    { name: "Turkey", tag: "TUR" },
    { name: "United Arab Emirates", tag: "ARE" },
    { name: "United Kingdom", tag: "GBR" },
    { name: "United States", tag: "USA" },
  ],
  es: [
    { name: "Emiratos Árabes Unidos", tag: "ARE" },
    { name: "Alemania", tag: "DEU" },
    { name: "Andorra", tag: "AND" },
    { name: "Australia", tag: "AUS" },
    { name: "Austria", tag: "AUT" },
    { name: "Blgica", tag: "BEL" },
    { name: "Canadá", tag: "CAN" },
    { name: "Chile", tag: "CHL" },
    { name: "China", tag: "CHN" },
    { name: "Colombia", tag: "COL" },
    { name: "Croatia", tag: "HRV" },
    { name: "Dinamarca", tag: "DNK" },
    { name: "Eslovaquia", tag: "SVK" },
    { name: "España", tag: "ESP" },
    { name: "Estados Unidos", tag: "USA" },
    { name: "Estonia", tag: "EST" },
    { name: "Finlandia", tag: "FIN" },
    { name: "Francia", tag: "FRA" },
    { name: "Grecia", tag: "GRC" },
    { name: "Holanda", tag: "NLD" },
    { name: "Hong Kong", tag: "HKG" },
    { name: "Hungra", tag: "HUN" },
    { name: "Irlanda", tag: "IRL" },
    { name: "Italia", tag: "ITA" },
    { name: "Jersey", tag: "JEY" },
    { name: "Katar", tag: "QAT" },
    { name: "Luxemburgo", tag: "LUX" },
    { name: "Malta", tag: "MLT" },
    { name: "Marroco", tag: "MAR" },
    { name: "Martinique", tag: "MTQ" },
    { name: "Mayotte", tag: "MYT" },
    { name: "Monaco", tag: "MCO" },
    { name: "Méjico", tag: "MEX" },
    { name: "Noruega", tag: "NOR" },
    { name: "Nueva Zelanda", tag: "NZL" },
    { name: "Polonia", tag: "POL" },
    { name: "Portugal", tag: "PRT" },
    { name: "Reino Unido", tag: "GBR" },
    { name: "Repblica Checa", tag: "CZE" },
    { name: "Romania", tag: "ROU" },
    { name: "Saint Barthélemy", tag: "BLM" },
    { name: "Saint Martin", tag: "MAF" },
    { name: "Singapur", tag: "SGP" },
    { name: "Slovenia", tag: "SVN" },
    { name: "Sudáfrica", tag: "ZAF" },
    { name: "Suecia", tag: "SWE" },
    { name: "Suiza", tag: "CHE" },
    { name: "Tailandia", tag: "THA" },
    { name: "Turquía", tag: "TUR" },
  ],
  fr: [
    { name: "Afrique du Sud", tag: "ZAF" },
    { name: "Allemagne", tag: "DEU" },
    { name: "Andorre", tag: "AND" },
    { name: "Australie", tag: "AUS" },
    { name: "Autriche", tag: "AUT" },
    { name: "Belgique", tag: "BEL" },
    { name: "Canada", tag: "CAN" },
    { name: "Chili", tag: "CHL" },
    { name: "Chine", tag: "CHN" },
    { name: "Colombie", tag: "COL" },
    { name: "Croatie", tag: "HRV" },
    { name: "Danemark", tag: "DNK" },
    { name: "Emirats Arabes Unis", tag: "ARE" },
    { name: "Espagne", tag: "ESP" },
    { name: "Estonie", tag: "EST" },
    { name: "Etats-Unis", tag: "USA" },
    { name: "Finlande", tag: "FIN" },
    { name: "France", tag: "FRA" },
    { name: "Grèce", tag: "GRC" },
    { name: "Hong Kong", tag: "HKG" },
    { name: "Hongrie", tag: "HUN" },
    { name: "Irlande", tag: "IRL" },
    { name: "Italie", tag: "ITA" },
    { name: "Jersey", tag: "JEY" },
    { name: "Luxembourg", tag: "LUX" },
    { name: "Malte", tag: "MLT" },
    { name: "Maroc", tag: "MAR" },
    { name: "Martinique", tag: "MTQ" },
    { name: "Mayotte", tag: "MYT" },
    { name: "Mexique", tag: "MEX" },
    { name: "Monaco", tag: "MCO" },
    { name: "Norvège", tag: "NOR" },
    { name: "Nouvelle Zélande", tag: "NZL" },
    { name: "Pays-Bas", tag: "NLD" },
    { name: "Pologne", tag: "POL" },
    { name: "Portugal", tag: "PRT" },
    { name: "Qatar", tag: "QAT" },
    { name: "Roumanie", tag: "ROU" },
    { name: "Royaume-Uni", tag: "GBR" },
    { name: "République Tchèque", tag: "CZE" },
    { name: "Saint Barthélemy", tag: "BLM" },
    { name: "Saint Martin", tag: "MAF" },
    { name: "Singapour", tag: "SGP" },
    { name: "Slovaquie", tag: "SVK" },
    { name: "Slovenia", tag: "SVN" },
    { name: "Suisse", tag: "CHE" },
    { name: "Suède", tag: "SWE" },
    { name: "Thaïlande", tag: "THA" },
    { name: "Turquie", tag: "TUR" },
  ],
  it: [
    { name: "Andorra", tag: "AND" },
    { name: "Australia", tag: "AUS" },
    { name: "Austria", tag: "AUT" },
    { name: "Belgio", tag: "BEL" },
    { name: "Canada", tag: "CAN" },
    { name: "Chile", tag: "CHL" },
    { name: "Cina", tag: "CHN" },
    { name: "Colombia", tag: "COL" },
    { name: "Croazia", tag: "HRV" },
    { name: "Danimarca", tag: "DNK" },
    { name: "Emirati Arabi Uniti", tag: "ARE" },
    { name: "Estonia", tag: "EST" },
    { name: "Finlandia", tag: "FIN" },
    { name: "Francia", tag: "FRA" },
    { name: "Germania", tag: "DEU" },
    { name: "Grecia", tag: "GRC" },
    { name: "Hong Kong", tag: "HKG" },
    { name: "Irlanda", tag: "IRL" },
    { name: "Italia", tag: "ITA" },
    { name: "Jersey", tag: "JEY" },
    { name: "Lussemburgo", tag: "LUX" },
    { name: "Malta", tag: "MLT" },
    { name: "Marroco", tag: "MAR" },
    { name: "Martinique", tag: "MTQ" },
    { name: "Mayotte", tag: "MYT" },
    { name: "Messico", tag: "MEX" },
    { name: "Monaco", tag: "MCO" },
    { name: "Norvegia", tag: "NOR" },
    { name: "Nuova Zelanda", tag: "NZL" },
    { name: "Olanda", tag: "NLD" },
    { name: "Polonia", tag: "POL" },
    { name: "Portogallo", tag: "PRT" },
    { name: "Qatar", tag: "QAT" },
    { name: "Regno unito", tag: "GBR" },
    { name: "Repubblica Ceca", tag: "CZE" },
    { name: "Romania", tag: "ROU" },
    { name: "Saint Barthélemy", tag: "BLM" },
    { name: "Saint Martin", tag: "MAF" },
    { name: "Singapore", tag: "SGP" },
    { name: "Slovacchia", tag: "SVK" },
    { name: "Slovenia", tag: "SVN" },
    { name: "Spagna", tag: "ESP" },
    { name: "Stati Uniti", tag: "USA" },
    { name: "Sud Africa", tag: "ZAF" },
    { name: "Svezia", tag: "SWE" },
    { name: "Svizzera", tag: "CHE" },
    { name: "Tailandia", tag: "THA" },
    { name: "Turchia", tag: "TUR" },
    { name: "Ungheria", tag: "HUN" },
  ],
};

export function getCountriesByLocale(locale: string): Country[] {
  const countriesHash = new Set(Object.keys(countries));
  if (countriesHash.has(locale)) {
    return countries[locale];
  }

  return [];
}
